import { CompanyDashboardsWidget } from '../components/widgets/company-dashboards.widget';
import { IWidgetDefinition } from '../types/widget-definition.interface';

export const CompanyDashboardsWidgetDefinition: IWidgetDefinition = {
  component: CompanyDashboardsWidget,
};
